
import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import RetryFailed from "../../../../common/src/components/RetryFailed.vue";

@Component({
    components: { RetryFailed },
})
export default class Loader extends Vue {
    @Prop() loading!: boolean;
    @Prop() failed!: boolean;
    @Prop({ default: "m-5" }) loaderClass!: string;

    @Emit()
    retry() {
        //
    }
}
